/**
 * Dashboard page
 *
 * created by Ty D'Angelo 10/17/2022
 */

import * as React from "react";
import { CenteredContainer } from "../ui/BaseComponents";
import ViewDashboard from "../dashboard/ViewDashboard";

export default function Dashboard() {
  
  return (
    <CenteredContainer>
      <ViewDashboard />
    </CenteredContainer>
  );
}
